import axios from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';

// TODO: Add types
export const fetchFavoritesIds = () => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/favorite-content-types`;

	return axios.get(requestUrl);
};

export const fetchFavorites = (query: string) => {
	const requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/contenttypes/${query}`;

	return axios.get(requestUrl, {
		withCredentials: false,
	});
};

export const addFavorite = (id: number, type: string) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/favorite-content-types`;

	return axios.post(requestUrl, {
		externalId: `${id}`,
		type,
	});
};

export const removeFavorite = (id: number, type: string) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/favorite-content-types/${type}/${id}`;

	return axios.delete(requestUrl);
};

export const checkIsFavorite = (id: number, type: string) => {
	const requestUrl = `${appConfig.env.urlSpringAPI}/profiles/favorite-content-types/${type}/${id}`;

	return axios.get(requestUrl);
};
